import React from 'react';
import { useNavigate } from 'react-router-dom';
import heroImage from '../../assets/images/hero.jpeg';
import { GetStartedButton } from '../common/GetStartedButton';

export const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative">
      {/* Main Hero Content */}
      <div className="w-full relative pt-20 sm:pt-24 lg:pt-28 pb-32 sm:pb-40 lg:pb-48 px-4 sm:px-6 lg:px-8 min-h-[700px] sm:min-h-[800px] flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src={heroImage}
            alt="Baseball player"
            className="w-full h-full object-cover object-center"
          />
          {/* Dark scrim keeps the headline readable in both themes */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B1220]/80 via-[#0B1220]/45 to-[#0B1220]/20"></div>
        </div>

        {/* Content Container */}
        <div className="max-w-7xl mx-auto relative z-10 w-full">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            {/* Left Side - Text Content */}
            <div className="flex-1 text-left">
              {/* Eyebrow */}
              <p className="text-yellow-300 text-sm sm:text-base font-bold uppercase tracking-widest mb-4">
                Stop Guessing &amp; Start Building
              </p>

              {/* Headline */}
              <h1 className="text-left text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-anton leading-[1.1] tracking-tight mb-6 sm:mb-8">
                <span className="text-white">NEVER </span>
                <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-cyan-500 text-transparent bg-clip-text">
                  "MISS"
                </span>
                <span className="text-white"> ON A</span>
                <br />
                <span className="text-white">RECRUIT AGAIN</span>
              </h1>

              {/* Subhead */}
              <p className="text-left text-sm sm:text-base md:text-lg text-gray-200 max-w-2xl leading-relaxed mb-2">
                Sortable Statistics. Easily Accessible Player Video. All JUCO Data in One Place.
              </p>
            </div>

            {/* Right Side - Button aligned with description */}
            <div className="flex justify-start lg:justify-end items-end pb-1">
              <GetStartedButton onClick={() => navigate('/auth/signup')}>
                START YOUR SEARCH
              </GetStartedButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
